import React, { forwardRef, useEffect, useImperativeHandle, useRef } from 'react';
import Konva from 'konva';
import { Stage, Layer, Path, Rect, Line, Group, Circle } from 'react-konva';

const default_cache_props = { pixelRatio:2, imageSmoothingEnabled:true, offset:5, drawBorder:false };

const TicketImage = (props) => {
	// 280 x 435

	const scale = props?.scale ?? 1;

	const refs = useRef({});

	useEffect(() => {
		refs.current['ticket_img'].cache(default_cache_props);
	}, []);

	const outline_props = {
		fill:'white',
		stroke:'gray',
		strokeWidth:1 / scale,
		lineCap:'round',
		lineJoin:'round',
	};

	const bar_props = {
		fill:'black',
		height:50,
	};

	const text_props = {
		fill:'black',
	};

	const article_line_props = {
		stroke:'black',
		strokeWidth:2 / scale,
	};

	return (
		<Group
			ref={(node) => { refs.current['ticket_img'] = node; }}
			scaleX={scale}
			scaleY={scale}
		>
			<Line
				points={[0,435, 20,420, 40,435, 60,420, 80,435, 100,420, 120,435, 140,420, 160,435, 180,420, 200,435, 220,420, 240,435, 260,420, 280,435, 280,0, 260,15, 240,0, 220,15, 200,0, 180,15, 160,0, 140,15, 120,0, 100,15, 80,0, 60,15, 40,0, 20,15, 0,0]}
				closed={true}
				{...outline_props}
			/>

			{/* CODEBAR - end */}
			<Group x={55} y={340}>
				<Rect
					{...bar_props}
					x={0.00}
					width={2.58}
				/>

				<Rect
					{...bar_props}
					x={124.17}
					width={1.87}
				/>

				<Rect
					{...bar_props}
					x={113.97}
					width={1.44}
				/>

				<Rect
					{...bar_props}
					x={119.9}
					width={1.87}
				/>

				<Rect
					{...bar_props}
					x={103.68}
					width={1.87}
				/>

				<Rect
					{...bar_props}
					x={93.36}
					width={4.67}
				/>

				<Rect
					{...bar_props}
					x={109.94}
					width={0.72}
				/>

				<Rect
					{...bar_props}
					x={128.29}
					width={0.72}
				/>

				<Rect
					{...bar_props}
					x={138.15}
					width={4.67}
				/>

				<Rect
					{...bar_props}
					x={156.13}
					width={1.44}
				/>

				<Rect
					{...bar_props}
					x={160.1}
					width={5.37}
				/>

				<Rect
					{...bar_props}
					x={151.43}
					width={2.4}
				/>

				<Rect
					{...bar_props}
					x={130.31}
					width={2.4}
				/>

				<Rect
					{...bar_props}
					x={134.97}
					width={0.72}
				/>

				<Rect
					{...bar_props}
					x={145.91}
					width={1.44}
				/>

				<Rect
					{...bar_props}
					x={88.2}
					width={2.4}
				/>

				<Rect
					{...bar_props}
					x={64.45}
					width={1.87}
				/>

				<Rect
					{...bar_props}
					x={16.17}
					width={2.4}
				/>

				<Rect
					{...bar_props}
					x={37.29}
					width={2.4}
				/>

				<Rect
					{...bar_props}
					x={22.65}
					width={1.44}
				/>

				<Rect
					{...bar_props}
					x={34.31}
					width={0.72}
				/>

				<Rect
					{...bar_props}
					x={27.18}
					width={4.67}
				/>

				<Rect
					{...bar_props}
					x={167.42}
					width={2.58}
				/>

				<Rect
					{...bar_props}
					x={12.43}
					width={1.44}
				/>

				<Rect
					{...bar_props}
					x={4.53}
					width={5.37}
				/>

				<Rect
					{...bar_props}
					x={59.34}
					width={0.72}
				/>

				<Rect
					{...bar_props}
					x={74.43}
					width={0.72}
				/>

				<Rect
					{...bar_props}
					x={82.37}
					width={1.87}
				/>

				<Rect
					{...bar_props}
					x={77.17}
					width={0.72}
				/>

				<Rect
					{...bar_props}
					x={48.23}
					width={1.87}
				/>

				<Rect
					{...bar_props}
					x={43.95}
					width={1.87}
				/>

				<Rect
					{...bar_props}
					x={40.99}
					width={0.72}
				/>

				<Rect
					{...bar_props}
					x={54.59}
					width={1.44}
				/>
			</Group>
			{/* CODEBAR - end */}

			{/* HEADER TITLE - ini */}
			<Group x={65} y={50}>
				<Path
					{...text_props}
					data="M0.47,35.95c-0.5-0.39-0.61-1-0.28-1.61l2.66-4.22c0.28-0.55,0.83-0.67,1.39-0.28c3.27,2.39,6.88,3.5,10.65,3.5c3.5,0,6.1-1.5,6.1-4.66c0-3.11-2.22-4.49-8.04-6.1C6.35,20.75,1.19,18.2,1.19,11.37C1.19,4.49,6.85,0,15.22,0c5.22,0,9.32,1.33,12.26,3.38c0.55,0.39,0.55,0.94,0.22,1.44l-2.39,3.94c-0.33,0.61-0.94,0.72-1.5,0.33c-2.44-1.55-5.16-2.44-8.65-2.44c-3.55,0-6.21,1.33-6.21,4.22c0,2.83,2.55,3.72,7.93,5.33c6.6,1.94,11.71,4.49,11.71,11.98C28.6,35.45,23.1,40,14.78,40C8.73,40,4.07,38.5,0.47,35.95z"
				/>

				<Path
					{...text_props}
					data="M69.01,1.5v37c0,0.61-0.39,1-1,1h-5.6c-0.67,0-1.05-0.39-1.05-1V23.36H41.38V38.5c0,0.61-0.39,1-1,1h-5.6c-0.67,0-1.05-0.39-1.05-1v-37c0-0.61,0.39-1,1.05-1h5.6c0.61,0,1,0.39,1,1v15.09h19.97V1.5c0-0.61,0.39-1,1.05-1h5.6C68.62,0.5,69.01,0.89,69.01,1.5z"
				/>

				<Path
					{...text_props}
					data="M74.14,20.08C74.14,8.77,82.85,0,94.78,0c11.82,0,20.42,8.54,20.42,20.08c0,11.43-8.6,19.92-20.42,19.92C82.85,40,74.14,31.35,74.14,20.08z M107.37,20.08c0-7.43-5.38-12.98-12.59-12.98c-7.38,0-12.82,5.6-12.82,12.98c0,7.32,5.44,12.87,12.82,12.87C101.99,32.95,107.37,27.46,107.37,20.08z"
				/>

				<Path
					{...text_props}
					data="M150,14.59c0,8.43-6.6,13.65-16.26,13.7h-5.77V38.5c0,0.61-0.39,1-1,1h-5.6c-0.67,0-1.05-0.39-1.05-1v-37c0-0.61,0.39-1,1.05-1h12.7C143.51,0.5,150,5.99,150,14.59z M142.12,14.48c0-3.94-3.11-7.21-8.43-7.21h-5.71v14.2h5.71C139.13,21.47,142.12,18.31,142.12,14.48z"
				/>
			</Group>
			{/* HEADER TITLE - end */}

			{/* HEADER SUBTITLE - ini */}
			<Group x={95} y={100}>
				<Path
					{...text_props}
					data="M11.78,14.81H9.1c-0.2,0-0.38-0.08-0.49-0.25l-2.86-3.93H5.37H3.06v3.81c0,0.23-0.16,0.37-0.4,0.37H0.42C0.16,14.81,0,14.67,0,14.44V0.56c0-0.23,0.16-0.37,0.42-0.37h5.15c3.79,0,6.32,2.02,6.32,5.28c0,2.08-1.13,3.66-3.06,4.51l3.24,4.37C12.25,14.63,12.11,14.81,11.78,14.81z M3.06,8.11H5.3c2.06,0,3.42-1.04,3.42-2.64c0-1.75-1.38-2.77-3.4-2.77H3.06V8.11z"
				/>

				<Path
					{...text_props}
					data="M25.6,12.67v1.77c0,0.23-0.16,0.37-0.4,0.37h-9.94c-0.27,0-0.42-0.15-0.42-0.37V0.56c0-0.23,0.16-0.37,0.42-0.37h9.85c0.27,0,0.42,0.15,0.42,0.37v1.77c0,0.25-0.16,0.4-0.42,0.4H17.9v3.43h6.3c0.27,0,0.42,0.15,0.42,0.4v1.77c0,0.23-0.16,0.37-0.42,0.37h-6.3v3.6h7.3C25.44,12.3,25.6,12.42,25.6,12.67z"
				/>

				<Path
					{...text_props}
					data="M27.4,7.51C27.4,3.27,30.7,0,35.69,0c2.4,0,3.99,0.71,4.84,1.21c0.22,0.12,0.24,0.33,0.13,0.54l-0.95,1.6c-0.13,0.23-0.33,0.27-0.55,0.12c-0.6-0.31-1.69-0.79-3.28-0.79c-3.22,0-5.32,1.89-5.32,4.81s2.09,4.83,5.32,4.83c1.6,0,2.68-0.46,3.28-0.77c0.22-0.12,0.42-0.08,0.55,0.12l0.95,1.6c0.11,0.21,0.11,0.4-0.18,0.56C39.82,14.25,38.22,15,35.69,15C30.68,15,27.4,11.73,27.4,7.51z"
				/>

				<Path
					{...text_props}
					data="M54,12.67v1.77c0,0.23-0.16,0.37-0.4,0.37h-9.94c-0.27,0-0.42-0.15-0.42-0.37V0.56c0-0.23,0.16-0.37,0.42-0.37h9.85c0.27,0,0.42,0.15,0.42,0.37v1.77c0,0.25-0.16,0.4-0.42,0.4H46.3v3.43h6.3c0.27,0,0.42,0.15,0.42,0.4v1.77c0,0.23-0.16,0.37-0.42,0.37h-6.3v3.6h7.3C53.84,12.3,54,12.42,54,12.67z"
				/>

				<Path
					{...text_props}
					data="M57.03,14.44V0.56c0-0.23,0.16-0.37,0.42-0.37h2.24c0.24,0,0.4,0.15,0.4,0.37v13.88c0,0.23-0.15,0.37-0.4,0.37h-2.24C57.19,14.81,57.03,14.67,57.03,14.44z"
				/>

				<Path
					{...text_props}
					data="M75.74,5.47c0,3.16-2.64,5.12-6.5,5.14h-2.31v3.83c0,0.23-0.16,0.37-0.4,0.37h-2.24c-0.27,0-0.42-0.15-0.42-0.37V0.56c0-0.23,0.16-0.37,0.42-0.37h5.08C73.14,0.19,75.74,2.25,75.74,5.47z M72.59,5.43c0-1.48-1.24-2.7-3.37-2.7h-2.29v5.33h2.29C71.39,8.05,72.59,6.87,72.59,5.43z"
				/>

				<Path
					{...text_props}
					data="M90,0.56v1.77c0,0.25-0.16,0.4-0.42,0.4h-4.75v11.71c0,0.23-0.16,0.37-0.42,0.37h-2.24c-0.27,0-0.4-0.15-0.4-0.37V2.73h-4.79c-0.27,0-0.4-0.15-0.4-0.4V0.56c0-0.23,0.13-0.37,0.4-0.37h12.6C89.84,0.19,90,0.33,90,0.56z"
				/>
			</Group>
			{/* HEADER SUBTITLE - end */}

			{/* TOTAL TEXT - ini */}
			<Group x={20} y={290}>
				<Path
					{...text_props}
					data="M16.96,0.75v2.36c0,0.33-0.2,0.53-0.53,0.53h-6v15.62c0,0.3-0.2,0.5-0.53,0.5H7.06c-0.34,0-0.51-0.19-0.51-0.5V3.63H0.5C0.17,3.63,0,3.44,0,3.11V0.75c0-0.31,0.17-0.5,0.5-0.5h15.92C16.76,0.25,16.96,0.44,16.96,0.75z"
				/>

				<Path
					{...text_props}
					data="M17.77,10.04C17.77,4.38,22.17,0,28.2,0c5.97,0,10.32,4.27,10.32,10.04c0,5.71-4.34,9.96-10.32,9.96C22.17,20,17.77,15.67,17.77,10.04z M34.56,10.04c0-3.72-2.72-6.49-6.36-6.49c-3.73,0-6.47,2.8-6.47,6.49c0,3.66,2.75,6.44,6.47,6.44C31.84,16.48,34.56,13.73,34.56,10.04z"
				/>

				<Path
					{...text_props}
					data="M56.34,0.75v2.36c0,0.33-0.2,0.53-0.53,0.53h-6v15.62c0,0.3-0.2,0.5-0.53,0.5h-2.83c-0.34,0-0.5-0.19-0.5-0.5V3.63h-6.05c-0.34,0-0.51-0.19-0.51-0.53V0.75c0-0.31,0.17-0.5,0.51-0.5h15.92C56.14,0.25,56.34,0.44,56.34,0.75z"
				/>

				<Path
					{...text_props}
					data="M73.58,19.75h-3c-0.28,0-0.48-0.14-0.59-0.42l-1.4-3.36h-8.44l-1.4,3.36c-0.11,0.28-0.31,0.42-0.59,0.42h-3c-0.39,0-0.56-0.22-0.42-0.58l8.21-18.53c0.08-0.25,0.34-0.39,0.62-0.39h1.68c0.28,0,0.5,0.14,0.62,0.39L74,19.17C74.14,19.53,73.97,19.75,73.58,19.75z M61.38,12.73h5.97l-2.97-7.05L61.38,12.73z"
				/>

				<Path
					{...text_props}
					data="M90,16.89v2.36c0,0.3-0.2,0.5-0.53,0.5H77.13c-0.34,0-0.53-0.19-0.53-0.5V0.75c0-0.31,0.2-0.5,0.53-0.5h2.83c0.31,0,0.5,0.19,0.5,0.5v15.65h9C89.8,16.39,90,16.56,90,16.89z"
				/>
			</Group>
			{/* TOTAL TEXT - end */}

			{/* TOTAL AMOUNT - ini */}
			<Group x={140} y={285}>
				<Path
					{...text_props}
					data="M10.05,23.91v2.44c0,0.41-0.24,0.62-0.64,0.62H6.17c-0.41,0-0.61-0.21-0.61-0.62v-2.27c-1.89-0.28-3.78-0.96-5.27-1.93¡c-0.3-0.21-0.37-0.48-0.2-0.86l1.08-2.3c0.17-0.38,0.51-0.48,0.84-0.24c1.62,0.96,3.31,1.55,5.13,1.55c2.2,0,3.61-0.79,3.61-2.1¡c0-1.89-2.5-2.48-5.06-3.3c-2.53-0.79-5.2-2.1-5.2-5.88c0-3.03,2.03-5.26,5.2-5.99V0.62C5.69,0.21,5.9,0,6.3,0h3.24¡c0.37,0,0.61,0.21,0.61,0.62v2.31c1.72,0.31,3.21,0.96,4.32,1.65c0.3,0.21,0.37,0.52,0.2,0.89L13.63,7.7¡c-0.17,0.38-0.47,0.48-0.84,0.24c-1.35-0.76-2.84-1.27-4.49-1.27c-1.99,0-3.31,0.86-3.31,2.17c0,1.34,1.55,1.96,3.44,2.51¡c2.9,0.89,6.68,2,6.68,6.54C15.11,20.91,13.22,23.11,10.05,23.91z"
				/>

				<Path
					{...text_props}
					data="M33.85,18.13c0,4.85-3.48,7.98-9.28,7.98c-3.07,0-5.37-0.89-6.79-1.82c-0.34-0.17-0.41-0.48-0.24-0.83l1.15-2.37¡c0.17-0.41,0.47-0.45,0.84-0.21c0.98,0.62,2.5,1.38,4.79,1.38c3.17,0,4.96-1.58,4.96-4.09s-1.65-3.92-4.59-3.92¡c-0.98,0-1.89,0.17-2.84,0.48c-0.37,0.1-0.64,0-0.81-0.38l-0.51-1.31c-0.14-0.31-0.1-0.62,0.17-0.89l6.35-6.54h-8.68¡c-0.41,0-0.61-0.21-0.61-0.62V2.24c0-0.38,0.2-0.62,0.61-0.62h13.77c0.41,0,0.64,0.24,0.64,0.62v1.89c0,0.31-0.1,0.52-0.3,0.76¡l-5.71,6.02h0.1C31.05,10.9,33.85,13.86,33.85,18.13z"
				/>

				<Path
					{...text_props}
					data="M54.1,17.96c0,4.85-3.54,8.15-8.51,8.15c-5.4,0-8.81-3.68-8.81-9.01c0-7.33,4.73-12.25,11.41-15.55¡c0.37-0.17,0.68-0.1,0.84,0.24l1.35,2.3c0.24,0.35,0.14,0.65-0.24,0.86c-3.65,1.82-6.62,4.03-8.1,6.98¡c1.15-1.13,2.7-1.79,4.52-1.79C51.07,10.15,54.1,13.38,54.1,17.96z M49.88,17.96c0-2.41-1.69-4.13-4.32-4.13¡c-2.53,0-4.32,1.75-4.32,3.99c0,2.48,1.76,4.3,4.35,4.3C48.2,22.12,49.88,20.43,49.88,17.96z"
				/>

				<Path
					{...text_props}
					data="M72.57,18.13c0,4.85-3.48,7.98-9.28,7.98c-3.07,0-5.37-0.89-6.79-1.82c-0.34-0.17-0.41-0.48-0.24-0.83l1.15-2.37¡c0.17-0.41,0.47-0.45,0.84-0.21c0.98,0.62,2.5,1.38,4.79,1.38c3.17,0,4.96-1.58,4.96-4.09s-1.65-3.92-4.59-3.92¡c-0.98,0-1.89,0.17-2.84,0.48c-0.37,0.1-0.64,0-0.81-0.38l-0.51-1.31c-0.14-0.31-0.1-0.62,0.17-0.89l6.35-6.54h-8.68¡c-0.41,0-0.61-0.21-0.61-0.62V2.24c0-0.38,0.2-0.62,0.61-0.62h13.77c0.41,0,0.64,0.24,0.64,0.62v1.89c0,0.31-0.1,0.52-0.3,0.76¡l-5.71,6.02h0.1C69.77,10.9,72.57,13.86,72.57,18.13z"
				/>

				<Path
					{...text_props}
					data="M76.89,29.72l-0.47-0.52c-0.24-0.31-0.2-0.62,0.14-0.9C77.4,27.52,78,26.59,78,25.94c-0.1,0.03-0.24,0.03-0.41,0.03¡c-1.22,0-2.09-0.93-2.13-2.34c-0.03-1.62,1.11-2.75,2.84-2.75c1.65,0,2.73,1.17,2.77,2.96c0.03,2.41-1.28,4.78-3.31,6.05¡C77.43,30.1,77.13,29.99,76.89,29.72z"
				/>

				<Path
					{...text_props}
					data="M100.08,10.35c0,7.46-4.83,12.42-11.45,15.51c-0.34,0.17-0.64,0.07-0.84-0.28l-1.28-2.2c-0.24-0.38-0.14-0.65,0.24-0.86¡c3.68-1.93,6.62-4.13,8.1-7.05c-1.11,1.13-2.67,1.79-4.49,1.79c-4.53,0-7.63-3.16-7.63-7.74c0-4.89,3.55-8.22,8.54-8.22¡C96.84,1.31,100.08,5.09,100.08,10.35z M95.66,9.46c0-2.41-1.79-4.2-4.35-4.2c-2.63,0-4.32,1.68-4.32,4.2¡c0,2.37,1.72,4.13,4.35,4.13C93.84,13.59,95.66,11.83,95.66,9.46z"
				/>

				<Path
					{...text_props}
					data="M120,10.35c0,7.46-4.83,12.42-11.44,15.51c-0.34,0.17-0.64,0.07-0.84-0.28l-1.28-2.2c-0.24-0.38-0.14-0.65,0.24-0.86¡c3.68-1.93,6.62-4.13,8.1-7.05c-1.11,1.13-2.67,1.79-4.49,1.79c-4.52,0-7.63-3.16-7.63-7.74c0-4.89,3.54-8.22,8.54-8.22¡C116.76,1.31,120,5.09,120,10.35z M115.58,9.46c0-2.41-1.79-4.2-4.36-4.2c-2.63,0-4.32,1.68-4.32,4.2c0,2.37,1.72,4.13,4.36,4.13¡C113.75,13.59,115.58,11.83,115.58,9.46z"
				/>
			</Group>
			{/* TOTAL AMOUNT - end */}

			{/* ARTICLE LINES - ini */}
			<Group x={20} y={150}>
				<Group y={0}>
					<Line
						{...article_line_props}
						points={[150, 10, 0,10]}
					/>
						
					<Path
						{...text_props}
						data="M189.93,13.64v1.85h-1.42v-1.83c-1.7-0.1-3.35-0.63-4.25-1.37l0.78-1.66c0.85,0.66,2.15,1.14,3.47,1.25v-3.3c-1.92-0.44-3.99-1.04-3.99-3.33c0-1.68,1.28-3.15,3.99-3.39V0h1.42v1.83c1.28,0.07,2.58,0.43,3.52,1.01l-0.71,1.66c-0.92-0.51-1.89-0.79-2.81-0.89v3.33c1.92,0.44,4.02,1.02,4.02,3.31C193.95,11.93,192.65,13.38,189.93,13.64z M188.5,6.59V3.66c-1.23,0.18-1.75,0.77-1.75,1.5C186.75,5.95,187.5,6.31,188.5,6.59z M191.73,10.4c0-0.81-0.76-1.19-1.8-1.47v2.92C191.19,11.67,191.73,11.11,191.73,10.4z"
					/>

					<Path
						{...text_props}
						data="M204.1,11.7v1.81h-8.94v-1.43l4.82-4.35c1.18-1.07,1.39-1.75,1.39-2.39c0-1.05-0.76-1.66-2.25-1.66c-1.18,0-2.17,0.38-2.84,1.2l-1.58-1.15c0.94-1.2,2.62-1.91,4.61-1.91c2.63,0,4.33,1.27,4.33,3.31c0,1.12-0.33,2.14-2.01,3.64l-3.24,2.93H204.1z"
					/>

					<Path
						{...text_props}
						data="M214.22,9.97c0,2.03-1.54,3.71-4.8,3.71c-1.72,0-3.45-0.49-4.56-1.33l0.95-1.66c0.88,0.69,2.2,1.14,3.57,1.14c1.61,0,2.57-0.68,2.57-1.76c0-1.1-0.74-1.8-3.26-1.8h-2.93l0.62-6.28h7.12v1.8h-5.22l-0.26,2.67h1.16C212.78,6.44,214.22,7.93,214.22,9.97z"
					/>

					<Path
						{...text_props}
						data="M218.29,12.26c0,0.36-0.09,0.66-0.4,1.42L217.01,16h-1.4l0.69-2.52c-0.49-0.2-0.81-0.63-0.81-1.22c0-0.82,0.61-1.37,1.4-1.37C217.7,10.89,218.29,11.45,218.29,12.26z"
					/>

					<Path
						{...text_props}
						data="M228.56,9.97c0,2.03-1.54,3.71-4.8,3.71c-1.72,0-3.45-0.49-4.56-1.33l0.95-1.66c0.88,0.69,2.2,1.14,3.57,1.14c1.61,0,2.57-0.68,2.57-1.76c0-1.1-0.74-1.8-3.26-1.8h-2.93l0.62-6.28h7.12v1.8h-5.22l-0.26,2.67h1.16C227.13,6.44,228.56,7.93,228.56,9.97z"
					/>

					<Path
						{...text_props}
						data="M229.86,7.74c0-3.79,2.18-5.93,5.06-5.93c2.89,0,5.08,2.14,5.08,5.93c0,3.79-2.18,5.93-5.08,5.93C232.04,13.68,229.86,11.53,229.86,7.74z M237.73,7.74c0-2.78-1.14-4.07-2.81-4.07c-1.65,0-2.79,1.29-2.79,4.07s1.14,4.07,2.79,4.07C236.59,11.81,237.73,10.53,237.73,7.74z"
					/>
				</Group>

				<Group y={30}>
					<Line
						{...article_line_props}
						points={[140,10, 0,10]}
					/>

					<Path
						{...text_props}
						data="M177.19,13.64v1.85h-1.42v-1.83c-1.7-0.1-3.35-0.63-4.25-1.37l0.78-1.66c0.85,0.66,2.15,1.14,3.47,1.25v-3.3c-1.92-0.44-3.99-1.04-3.99-3.33c0-1.68,1.28-3.15,3.99-3.39V0h1.42v1.83c1.28,0.07,2.58,0.43,3.52,1.01L180,4.5c-0.92-0.51-1.89-0.79-2.81-0.89v3.33c1.92,0.44,4.02,1.02,4.02,3.31C181.21,11.93,179.91,13.38,177.19,13.64z M175.77,6.59V3.66c-1.23,0.18-1.75,0.77-1.75,1.5C174.02,5.95,174.77,6.31,175.77,6.59z M179,10.4c0-0.81-0.76-1.19-1.8-1.47v2.92C178.46,11.67,179,11.11,179,10.4z"
					/>

					<Path
						{...text_props}
						data="M191.37,11.7v1.81h-8.94v-1.43l4.82-4.35c1.18-1.07,1.39-1.75,1.39-2.39c0-1.05-0.76-1.66-2.25-1.66c-1.18,0-2.17,0.38-2.84,1.2l-1.58-1.15c0.94-1.2,2.62-1.91,4.61-1.91c2.63,0,4.33,1.27,4.33,3.31c0,1.12-0.33,2.14-2.01,3.64l-3.24,2.93H191.37z"
					/>

					<Path
						{...text_props}
						data="M202,7.55c0,3.95-2.43,6.13-5.94,6.13c-1.21,0-2.37-0.25-3.19-0.74l0.83-1.62c0.66,0.41,1.45,0.56,2.3,0.56c2.29,0,3.73-1.35,3.73-3.97V7.89c-0.73,0.81-1.89,1.2-3.24,1.2c-2.39,0-4.18-1.38-4.18-3.54c0-2.29,1.96-3.74,4.44-3.74C200.06,1.81,202,3.84,202,7.55z M199.39,5.44c0-1.09-0.9-1.94-2.51-1.94c-1.4,0-2.37,0.76-2.37,1.96c0,1.2,0.95,1.96,2.43,1.96C198.38,7.42,199.39,6.57,199.39,5.44z"
					/>

					<Path
						{...text_props}
						data="M212.87,7.55c0,3.95-2.43,6.13-5.94,6.13c-1.21,0-2.37-0.25-3.19-0.74l0.83-1.62c0.66,0.41,1.45,0.56,2.3,0.56c2.29,0,3.73-1.35,3.73-3.97V7.89c-0.73,0.81-1.89,1.2-3.24,1.2c-2.39,0-4.18-1.38-4.18-3.54c0-2.29,1.96-3.74,4.44-3.74C210.93,1.81,212.87,3.84,212.87,7.55z M210.25,5.44c0-1.09-0.9-1.94-2.51-1.94c-1.4,0-2.37,0.76-2.37,1.96c0,1.2,0.95,1.96,2.43,1.96C209.25,7.42,210.25,6.57,210.25,5.44z"
					/>

					<Path
						{...text_props}
						data="M216.96,12.26c0,0.36-0.09,0.66-0.4,1.42L215.67,16h-1.4l0.69-2.52c-0.49-0.2-0.81-0.63-0.81-1.22c0-0.82,0.61-1.37,1.41-1.37C216.36,10.89,216.96,11.45,216.96,12.26z"
					/>

					<Path
						{...text_props}
						data="M218.2,7.74c0-3.79,2.18-5.93,5.06-5.93c2.89,0,5.08,2.14,5.08,5.93c0,3.79-2.18,5.93-5.08,5.93C220.38,13.68,218.2,11.53,218.2,7.74z M226.07,7.74c0-2.78-1.14-4.07-2.81-4.07c-1.65,0-2.79,1.29-2.79,4.07s1.14,4.07,2.79,4.07C224.93,11.81,226.07,10.53,226.07,7.74z"
					/>

					<Path
						{...text_props}
						data="M229.86,7.74c0-3.79,2.18-5.93,5.06-5.93c2.89,0,5.08,2.14,5.08,5.93c0,3.79-2.18,5.93-5.08,5.93C232.04,13.68,229.86,11.53,229.86,7.74z M237.73,7.74c0-2.78-1.14-4.07-2.81-4.07c-1.65,0-2.79,1.29-2.79,4.07s1.14,4.07,2.79,4.07C236.59,11.81,237.73,10.53,237.73,7.74z"
					/>
				</Group>

				<Group y={60}>
					<Line
						{...article_line_props}
						points={[160,10, 0,10]}
					/>

					<Path
						{...text_props}
						data="M190.01,13.64v1.85h-1.42v-1.83c-1.7-0.1-3.35-0.63-4.25-1.37l0.78-1.66c0.85,0.66,2.15,1.14,3.47,1.25v-3.3c-1.92-0.44-3.99-1.04-3.99-3.33c0-1.68,1.28-3.15,3.99-3.39V0h1.42v1.83c1.28,0.07,2.58,0.43,3.52,1.01l-0.71,1.66c-0.92-0.51-1.89-0.79-2.81-0.89v3.33c1.92,0.44,4.02,1.02,4.02,3.31C194.03,11.93,192.73,13.38,190.01,13.64z M188.59,6.59V3.66c-1.23,0.18-1.75,0.77-1.75,1.5C186.84,5.95,187.59,6.31,188.59,6.59z M191.82,10.4c0-0.81-0.76-1.19-1.8-1.47v2.92C191.28,11.67,191.82,11.11,191.82,10.4z"
					/>

					<Path
						{...text_props}
						data="M203.93,10.05c0,1.94-1.54,3.63-4.8,3.63c-1.72,0-3.43-0.49-4.56-1.33l0.97-1.66c0.87,0.69,2.18,1.14,3.55,1.14c1.61,0,2.57-0.68,2.57-1.75c0-1.04-0.8-1.71-2.63-1.71h-1.11V6.89l2.75-3.11h-5.51v-1.8h8.27v1.43l-2.95,3.33C202.77,7.02,203.93,8.32,203.93,10.05z"
					/>

					<Path
						{...text_props}
						data="M214.1,11.7v1.81h-8.94v-1.43l4.82-4.35c1.18-1.07,1.39-1.75,1.39-2.39c0-1.05-0.76-1.66-2.25-1.66c-1.18,0-2.17,0.38-2.84,1.2l-1.58-1.15c0.94-1.2,2.62-1.91,4.61-1.91c2.63,0,4.33,1.27,4.33,3.31c0,1.12-0.33,2.14-2.01,3.64l-3.24,2.93H214.1z"
					/>

					<Path
						{...text_props}
						data="M218.34,12.26c0,0.36-0.09,0.66-0.4,1.42L217.06,16h-1.4l0.69-2.52c-0.49-0.2-0.81-0.63-0.81-1.22c0-0.82,0.61-1.37,1.4-1.37C217.75,10.89,218.34,11.45,218.34,12.26z"
					/>

					<Path
						{...text_props}
						data="M229.14,7.55c0,3.95-2.43,6.13-5.94,6.13c-1.21,0-2.37-0.25-3.19-0.74l0.83-1.62c0.66,0.41,1.45,0.56,2.3,0.56c2.29,0,3.73-1.35,3.73-3.97V7.89c-0.73,0.81-1.89,1.2-3.24,1.2c-2.39,0-4.18-1.38-4.18-3.54c0-2.29,1.96-3.74,4.44-3.74C227.19,1.81,229.14,3.84,229.14,7.55z M226.52,5.44c0-1.09-0.9-1.94-2.51-1.94c-1.4,0-2.37,0.76-2.37,1.96c0,1.2,0.95,1.96,2.43,1.96C225.51,7.42,226.52,6.57,226.52,5.44z"
					/>

					<Path
						{...text_props}
						data="M240,7.55c0,3.95-2.43,6.13-5.94,6.13c-1.21,0-2.37-0.25-3.19-0.74l0.83-1.62c0.66,0.41,1.45,0.56,2.3,0.56c2.29,0,3.73-1.35,3.73-3.97V7.89c-0.73,0.81-1.89,1.2-3.24,1.2c-2.39,0-4.18-1.38-4.18-3.54c0-2.29,1.96-3.74,4.44-3.74C238.06,1.81,240,3.84,240,7.55z M237.38,5.44c0-1.09-0.9-1.94-2.51-1.94c-1.4,0-2.37,0.76-2.37,1.96c0,1.2,0.95,1.96,2.43,1.96C236.38,7.42,237.38,6.57,237.38,5.44z"
					/>
				</Group>

				<Group y={90}>
					<Line
						{...article_line_props}
						points={[110,10, 0,10]}
					/>

					<Path
						{...text_props}
						data="M199.09,13.64v1.85h-1.42v-1.83c-1.7-0.1-3.35-0.63-4.25-1.37l0.78-1.66c0.85,0.66,2.15,1.14,3.47,1.25v-3.3c-1.92-0.44-3.99-1.04-3.99-3.33c0-1.68,1.28-3.15,3.99-3.39V0h1.42v1.83c1.28,0.07,2.58,0.43,3.52,1.01L201.9,4.5c-0.92-0.51-1.89-0.79-2.81-0.89v3.33c1.92,0.44,4.02,1.02,4.02,3.31C203.11,11.93,201.81,13.38,199.09,13.64z M197.67,6.59V3.66c-1.23,0.18-1.75,0.77-1.75,1.5C195.92,5.95,196.67,6.31,197.67,6.59z M200.89,10.4c0-0.81-0.76-1.19-1.8-1.47v2.92C200.36,11.67,200.89,11.11,200.89,10.4z"
					/>

					<Path
						{...text_props}
						data="M214.17,9.94c0,2.29-1.96,3.74-4.44,3.74c-3.31,0-5.25-2.03-5.25-5.73c0-3.95,2.43-6.13,5.95-6.13c1.21,0,2.37,0.25,3.19,0.74l-0.83,1.62c-0.66-0.41-1.46-0.56-2.31-0.56c-2.29,0-3.73,1.35-3.73,3.97V7.6c0.73-0.81,1.89-1.2,3.24-1.2C212.38,6.39,214.17,7.78,214.17,9.94z M211.98,10.03c0-1.2-0.95-1.96-2.43-1.96c-1.46,0-2.46,0.84-2.46,1.98c0,1.09,0.9,1.94,2.51,1.94C211.01,12,211.98,11.24,211.98,10.03z"
					/>

					<Path
						{...text_props}
						data="M218.29,12.26c0,0.36-0.09,0.66-0.4,1.42L217.01,16h-1.4l0.69-2.52c-0.49-0.2-0.81-0.63-0.81-1.22c0-0.82,0.61-1.37,1.4-1.37C217.7,10.89,218.29,11.45,218.29,12.26z"
					/>

					<Path
						{...text_props}
						data="M228.56,9.97c0,2.03-1.54,3.71-4.8,3.71c-1.72,0-3.45-0.49-4.56-1.33l0.95-1.66c0.88,0.69,2.2,1.14,3.57,1.14c1.61,0,2.57-0.68,2.57-1.76c0-1.1-0.74-1.8-3.26-1.8h-2.93l0.62-6.28h7.12v1.8h-5.22l-0.26,2.67h1.16C227.13,6.44,228.56,7.93,228.56,9.97z"
					/>

					<Path
						{...text_props}
						data="M229.86,7.74c0-3.79,2.18-5.93,5.06-5.93c2.89,0,5.08,2.14,5.08,5.93c0,3.79-2.18,5.93-5.08,5.93C232.04,13.68,229.86,11.53,229.86,7.74z M237.73,7.74c0-2.78-1.14-4.07-2.81-4.07c-1.65,0-2.79,1.29-2.79,4.07s1.14,4.07,2.79,4.07C236.59,11.81,237.73,10.53,237.73,7.74z"
					/>
				</Group>
			</Group>
		</Group>
	)
};

const Image = forwardRef((props, ref) => {
	// 660 x 570

	const refs = useRef({});
	
	const type = props?.type ?? 'ok';
	const scale = props?.scale ?? 1;

	const bg_props = {
		fill:'rgba(245, 245, 245, 1)',
		width:660,
		height:570,
	};

	const highlight_color = (type == 'ok') ? '120, 195, 0' : '215, 35, 60';

	useImperativeHandle(ref, () => ({
		highlightBg(direction = 1) {
			if(type == 'ok') return;

			refs.current['bg'].to({
				opacity:(direction > 0) ? 0.4 : 0,
				duration:1,
				easing:Konva.Easings.StrongEaseOut,
			});
		},
	}), []);

	return (
		<>
			<Rect
				{...bg_props}
			/>

			<Rect
				ref={(node) => { refs.current['bg'] = node; }}
				{...bg_props}
				fill={`rgba(${highlight_color}, 1)`}
				opacity={0}
			/>

			<Group
				x={190}
				y={67.5}
				scaleX={1 / scale}
				scaleY={1 / scale}
			>
				<TicketImage
					{...props}
				/>
			</Group>
		</>
	)
});

const SingleTicketCase = (props) => {
	const refs = useRef({});
	const crop = { t:0.05, b:0.95, l:0.05, r:0.95 };
	const crop_ok = { t:0.15, b:0.85, l:0.3, r:0.7 };
	const crop_ko = { t:0.08, b:0.92, l:0.1, r:0.9 };

	const type = props?.type ?? 'ok';
	const original_size = props?.original_size ?? { w:660, h:570 };
	const scale = props?.scale ?? 1;

	const controls_color = `rgba(${props?.items_color ?? '255, 255, 255'}, 1)`;
	const controls_stroke_color = `rgba(${props?.bg_color ?? '0, 0, 0'}, 1)`;
	const highlight_color = (type == 'ok') ? '120, 195, 0' : '215, 35, 60';

	const mid_point_keys = ['t', 'b', 'l', 'r'];
	const corner_point_keys = ['tl', 'bl', 'tr', 'br'];

	const visual_dragger_radius = 10;

	const getPointPosition = (point, crop_coords) => {
		let x;
		let y;

		if(['t', 'tl', 'tr'].includes(point)) {
			y = original_size.h * crop_coords.t;
		} else if(['b', 'bl', 'br'].includes(point)) {
			y = original_size.h * crop_coords.t + original_size.h * (crop_coords.b - crop_coords.t);
		} else {
			y = original_size.h * crop_coords.t + (original_size.h * (crop_coords.b - crop_coords.t)) / 2;
		}

		if(['l', 'tl', 'bl'].includes(point)) {
			x = original_size.w * crop_coords.l;
		} else if(['r', 'tr', 'br'].includes(point)) {
			x = original_size.w * crop_coords.l + original_size.w * (crop_coords.r - crop_coords.l);
		} else {
			x = original_size.w * crop_coords.l + (original_size.w * (crop_coords.r - crop_coords.l)) / 2;
		}

		return { x, y };
	};

	const animateArea = (coords, direction = 1, cb) => {
		if(refs.current['crop_line'] == undefined) return;

		const animation_generic_props = {
			duration:1,
			easing:Konva.Easings.StrongEaseOut,
		};

		const animation_new_props = {
			x:original_size.w * coords.l,
			y:original_size.h * coords.t,
			points:[
				0, 0,
				original_size.w * (coords.r - coords.l), 0,
				original_size.w * (coords.r - coords.l), original_size.h * (coords.b - coords.t),
				0, original_size.h * (coords.b - coords.t),
			],
		};

		[ ...mid_point_keys, ...corner_point_keys ].map((point) => {
			const { x, y } = getPointPosition(point, { ...coords });

			if(refs.current[`dragger_${point}`] == undefined) return;

			refs.current[`dragger_${point}`].to({
				x,
				y,
				...animation_generic_props,
			});
		});

		refs.current['image'].to({
			scaleX:(coords.r - coords.l) / (crop.r - crop.l),
			scaleY:(coords.b - coords.t) / (crop.b - crop.t),
			...animation_generic_props,
		});

		refs.current['crop_line_shadow'].to({
			...animation_new_props,
			...animation_generic_props,
		});

		refs.current['ticket'].highlightBg(direction);

		refs.current['crop_line'].to({
			...animation_new_props,
			stroke:(direction > 0) ? `rgba(${highlight_color}, 1)` : controls_color,
			...animation_generic_props,
			onFinish:() => {
				if(refs.current['crop_line'] == undefined || cb == undefined) return;

				if(direction > 0 && refs.current['tick'] != undefined) {
					refs.current['tick'].setAttrs({
						opacity:1,
					});
				}

				setTimeout(() => {
					if(direction > 0 && refs.current['tick'] != undefined) {
						refs.current['tick'].setAttrs({
							opacity:0,
						});
					}

					cb();
				}, 1000);
			},
		});
	};

	const animatePointsOK = (direction = 1) => {
		const final_crop = (direction > 0) ? { ...crop_ok } : { ...crop };
		animateArea(final_crop, direction, () => animatePointsOK(-1 * direction));
	};

	const animatePointsKO = (direction = 1) => {
		const final_crop = (direction > 0) ? { ...crop_ko } : { ...crop };
		animateArea(final_crop, direction, () => animatePointsKO(-1 * direction));
	};

	useEffect(() => {
		(type == 'ko') ? animatePointsKO() : animatePointsOK();
	}, []);

	const mask_w = 3 * original_size.w;
	const mask_h = 3 * original_size.h;
	const mask_hole_w = original_size.w * (crop.r - crop.l);
	const mask_hole_h = original_size.h * (crop.b - crop.t);

	return (
		<>
			<Image
				ref={(node) => { refs.current['ticket'] = node; }}
				scale={scale}
				type={type}
			/>

			<Path
				ref={(node) => { refs.current['image'] = node; }}
				data={`M${-mask_w / 2}${-mask_h / 2}V${mask_h / 2}H${mask_w / 2}V${-mask_h / 2}H${-mask_w / 2}z M${mask_hole_w / 2},${mask_hole_h / 2}h${-mask_hole_w}v${-mask_hole_h}h${mask_hole_w}V${mask_hole_h / 2}z`}
				fill='black'
				opacity={0.6}
				x={original_size.w / 2}
				y={original_size.h / 2}
			/>

			<Line
				ref={(node) => { refs.current['crop_line_shadow'] = node; }}
				stroke={controls_stroke_color}
				strokeWidth={5 / scale}
				x={original_size.w * crop.l}
				y={original_size.h * crop.t}
				points={[
					0, 0,
					original_size.w * (crop.r - crop.l), 0,
					original_size.w * (crop.r - crop.l), original_size.h * (crop.b - crop.t),
					0, original_size.h * (crop.b - crop.t),
				]}
				closed={true}
			/>

			<Line
				ref={(node) => { refs.current['crop_line'] = node; }}
				stroke={controls_color}
				strokeWidth={2 / scale}
				x={original_size.w * crop.l}
				y={original_size.h * crop.t}
				points={[
					0, 0,
					original_size.w * (crop.r - crop.l), 0,
					original_size.w * (crop.r - crop.l), original_size.h * (crop.b - crop.t),
					0, original_size.h * (crop.b - crop.t),
				]}
				closed={true}
			/>

			{[ ...mid_point_keys, ...corner_point_keys ].map((point) => {
				const { x, y } = getPointPosition(point, { ...crop });

				return (
					<Circle
						key={`visual_dragger_${point}`}
						ref={(node) => { refs.current[`dragger_${point}`] = node; }}
						radius={visual_dragger_radius}
						x={x}
						y={y}
						fill={controls_color}
						strokeWidth={2}
						stroke={controls_stroke_color}
					/>
				)
			})}

			<Group
				ref={(node) => { refs.current['tick'] = node; }}
				x={original_size.w / 2}
				y={original_size.h / 2}
				scaleX={1.7}
				scaleY={1.7}
				opacity={0}
			>
				<Circle
					radius={25}
					fill={`rgba(${highlight_color}, 1)`}
					stroke='black'
					strokeWidth={2 / scale / 1.7}
				/>

				<Line
					points={(type == 'ok') ? [19.29,-9.01, 13.33,-15, -4.6,3.04, -13.34,-5.75, -19.29,0.24, -4.61,15, -4.6,14.98, -4.58,15] : [15,-8.94, 8.94,-15, 0,-6.06, -8.94,-15, -15,-8.94, -6.06,0, -15,8.94, -8.94,15, 0,6.06, 8.94,15, 15,8.94, 6.06,0]}
					fill='white'
					closed={true}
				/>
			</Group>
		</>
	)
};

const TicketCropperInstructions = (props) => {
	const refs = useRef({});

	const final_w = parseInt(props?.width ?? 400);

	const cases_separation = 30;
	
	const original_size = { w:660, h:570 };
	const total_size = { w:original_size.w * 2 + cases_separation, h:original_size.h };

	const size = { w:final_w, h:final_w * total_size.h / total_size.w };
	const scale = final_w / total_size.w;

	const main_classes = [];

	return (
		<Stage
			class={main_classes.join(" ")}
			width={size.w}
			height={size.h}
		>
			<Layer
				scaleX={scale}
				scaleY={scale}
			>
				<Group
					clipFunc={(ctx) => {
						ctx.rect(0, 0, original_size.w, original_size.h);
					}}
				>
					<SingleTicketCase
						type='ko'
						scale={scale}
						original_size={original_size}
					/>
				</Group>

				<Group
					x={original_size.w + cases_separation}
					clipFunc={(ctx) => {
						ctx.rect(0, 0, original_size.w, original_size.h);
					}}
				>
					<SingleTicketCase
						type='ok'
						scale={scale}
						original_size={original_size}
					/>
				</Group>
			</Layer>
		</Stage>
	)
};

export default TicketCropperInstructions;